var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.imgUrl)?_c('img',{directives:[{name:"lazy",rawName:"v-lazy",value:(_vm.imgUrl),expression:"imgUrl"}],attrs:{"src":_vm.emptyImg}}):_c('img',{attrs:{"src":_vm.emptyImg}})])
}
var staticRenderFns = []

export { render, staticRenderFns }